<!-- =========================================================================================
  File Name: StockTransaction.vue
  Description: Stock transaction Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <upload-file :isActive="uploadFileActive" :uploadURL="fileUploadURL" :context="this.$store.state.AppActiveUser" @closeFileUpload="closeFileUpload"/>

    <vs-alert color="danger" title="Transacción de inventario no encontrada" :active.sync="id_not_found">
      <span>Datos de transacción de inventario con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'sock_transactions'}" class="text-inherit underline"> todas las transacciones de inventario</router-link>
      </span>
    </vs-alert>

    <vx-card v-show="loaded" class="mb-2">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <div class="vx-col flex-1">
            <div class="w-full vx-row">
              <div class="vx-col w-1/3">
                <h2 class="text-blue-800 text-bold mb-2">{{ data_local.document }}</h2>
              </div>
              <div class="vx-col w-1/3">
                <ejs-datetimepicker floatLabelType="Auto" placeholder="Fecha" v-model="data_local.date" locale="es-GT" :enabled="editing"></ejs-datetimepicker>
              </div>
              <div class="vx-col w-1/3 text-right">
                <label style="font-size: smaller;" v-if="data_local.statusName">Estado</label><br/>
                <b class="text-blue-800 text-bold">{{ data_local.statusName }}</b>
              </div>
            </div>
            <div class="w-full vx-row">
              <div class="vx-col w-1/2">
                <ejs-dropdownlist highlight=true floatLabelType="Auto" placeholder="Tipo de documento" :dataSource="documentTypes" :fields="{text: 'name', value: 'code'}" v-model="data_local.documentType" :enabled="editing"/>
              </div>
              <div class="vx-col w-1/2">
                <ejs-dropdownlist highlight=true floatLabelType="Auto" placeholder="Bodega" :dataSource="warehouses" :fields="{text: 'name', value: 'id'}" v-model="data_local.warehouseId" :enabled="editing"/>
              </div>
            </div>
            <div class="w-full">
              <ejs-textbox name="comments" :multiline="true" floatLabelType="Auto" placeholder="Comentarios" v-model="data_local.comments" :enabled="editing"/>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mt-2 mb-2">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button icon-pack="feather" icon="icon-upload" class="mr-4" color="success" v-show="editing" @click="openUploadFile">Cargar archivo</vs-button>
              <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" v-show="!editing" @click="editing = true">Editar</vs-button>
              <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" v-show="!editing" @click="confirmDeleteRecord">Eliminar</vs-button>
              <vs-button class="ml-auto" @click="save" v-show="editing && !editingGrid" :disabled="!validateForm">Guardar cambios</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data" v-show="editing && !editingGrid">Cancelar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card>
      <div class="flex flex-wrap items-center">
        <ejs-grid v-if="loaded" ref="grid" id="grdStockTransactionDetail" :dataSource="lines" :load='load' locale='es-GT' :toolbar='toolbarOptions' height="400px" :pageSettings='pageSettings' :editSettings='editSettings'
                  :actionBegin='gridActionBegin' :actionComplete="gridActionComplete">
          <e-columns>
            <e-column field="productId"
                      headerText="Código del producto"
                      width="350"
                      :dataSource="products"
                      :fields="productEditFields"
                      foreignKeyField="id"
                      foreignKeyValue="code"
                      :edit="productEditParams"
            />
            <e-column field="productName" headerText="Nombre del producto" :allowEditing="false"/>
            <e-column field="quantity" headerText="Cantidad" textAlign='Right' format="N2" editType='numericedit' :edit='numericParams' width="140"/>
            <e-column headerText='Acciones' width="130" :commands='commands' :visible="editing"/>
            <e-column field="id" :visible=false headerText="ID" :isPrimaryKey="true" :allowEditing="false"/>
          </e-columns>
        </ejs-grid>
      </div>
    </vx-card>
  </div>
</template>

<script>
  // import {AgGridVue} from "ag-grid-vue";

  var deltaPOS_config = require('@/deltaPOS.config.js')

  import Vue from "vue";
  import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
  import {Query} from "@syncfusion/ej2-data";
  import {GridPlugin, Toolbar, Search, Edit, CommandColumn, ForeignKey} from '@syncfusion/ej2-vue-grids';
  import {AutoComplete} from '@syncfusion/ej2-dropdowns';
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";
  import {DateTimePickerPlugin} from '@syncfusion/ej2-vue-calendars';

  import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
  import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
  import numbers from 'cldr-data/main/es-GT/numbers.json';
  import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
  import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week

  Vue.use(GridPlugin, AutoComplete);
  Vue.use(TextBoxPlugin);
  Vue.use(DropDownListPlugin);
  Vue.use(DateTimePickerPlugin);

  loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);

  setCulture('es-GT');
  L10n.load({
    'es-GT': {
      'datetimepicker': {
        placeholder: 'Especifique fecha',
        today: 'Hoy'
      },
      'grid': {
        'EmptyRecord': 'Transacción no tiene productos',
        'Search': 'Buscar',
        'Add': 'Agregar',
        'Edit': 'Modificar',
        'Cancel': 'Cancelar',
        'Update': 'Guardar',
        'Delete': 'Eliminar'
      }
    }
  });

  var elemProduct;
  var productObj;
  var elemWarehouse;
  var warehouseObj;

  export default {
    data() {
      return {
        loaded: false,
        editing: false,
        editingGrid: false,
        uploadFileActive: false,
        loadedLines: [],
        pageSettings: {pageSize: 10},
        pagination: [10, 25, 50, 100],
        toolbarOptions: ['Search', 'Add', 'Update', 'Cancel'],
        editSettings: {allowEditing: true, allowAdding: false, allowDeleting: true, newRowPosition: 'Bottom', editMode: 'batch'},
        numericParams: {
          params: {
            validateDecimalOnType: true,
            decimals: 4,
            format: "N"
          }
        },
        commands: [
          {type: 'Edit', buttonOption: {cssClass: 'e-flat', iconCss: 'e-edit e-icons'}},
          {type: 'Delete', buttonOption: {cssClass: 'e-flat', iconCss: 'e-delete e-icons'}},
          {type: 'Cancel', buttonOption: {cssClass: 'e-flat', iconCss: 'e-cancel e-icons'}},
          {type: 'Update', buttonOption: {cssClass: 'e-flat', iconCss: 'e-update e-icons'}}
        ],
        allowFiltering: true,
        queryProduct: new Query().select(['searchName', 'id']).take(10),
        queryWarehouse: new Query().select(['name', 'id']).take(10),
        warehouseEditParams: {
          create: function () {
            elemWarehouse = document.createElement('input');
            return elemWarehouse;
          },
          read: () => {
            return warehouseObj.value;
          },
          destroy: () => {
            warehouseObj.destroy();
          },
          write: (args) => {
            warehouseObj = new AutoComplete({
              value: args.rowData[args.column.field],
              dataSource: args.column.columnData,
              fields: {text: 'name', value: 'id'},
              ignoreAccent: true,
              ignoreCase: true,
              allowFiltering: true,
              filtering: this.warehouseFiltering,
              highlight: 'highlight'
            });
            warehouseObj.appendTo(elemWarehouse);
          }
        },
        productEditParams: {
          create: function () {
            elemProduct = document.createElement('input');
            return elemProduct;
          },
          read: () => {
            return productObj.value;
          },
          destroy: () => {
            productObj.destroy();
          },
          write: (args) => {
            productObj = new AutoComplete({
              width: 600,
              value: args.rowData[args.column.field],
              dataSource: args.column.columnData,
              fields: {text: 'code', value: 'id'},
              itemTemplate: '<span><span>${code}</span><span style="right: 0; width: 500px; position:absolute;">${name}</span></span>',
              ignoreAccent: true,
              ignoreCase: true,
              allowFiltering: true,
              filtering: this.productFiltering,
              highlight: 'highlight',
              select: (args) => {
                document.querySelector("#grdStockTransactionDetailproductName").value = args.itemData.name;
              }
            });
            productObj.appendTo(elemProduct);
          }
        },
        productEditFields: {text: 'code', value: 'id'},
        warehouseEditFields: {text: 'name', value: 'id'},
        documentTypes: [],
        warehouses: [],
        status: [],
        products: [],
        data: null,
        data_local: {
          id: 0,
          documentType: '',
          documentTypeName: '',
          document: '',
          date: new Date(),
          statusId: 'OPE',
          statusName: '',
          comments: '',
          posReference: this.uuidv4(),
          origin: 'deltaPOS'
        },
        lines: [],
        id_not_found: false,
        posReference: '',
      }
    },
    components: {
      UploadFile: () => import('../../components/Upload')
    },
    provide: {
      grid: [Toolbar, Search, Edit, CommandColumn, ForeignKey]
    },
    watch: {
      editing: function (enable) {
        this.loadLines(enable);
      }
    },
    computed: {
      fileUploadURL() {
        return `${deltaPOS_config.default.apiURL}/stock/transactions/upload`;
      }
    },
    methods: {
      test: function () {
        console.log(this.$refs.grid.ej2Instances.dataSource);
      },
      loadLines(enable) {
        if (this.data) {
          if (this.data.products) {
            this.lines = JSON.parse(JSON.stringify(this.data.products));
          }
        }
        if (this.$refs.grid) {
          this.$refs.grid.ej2Instances.editSettings.allowAdding = enable;
          this.$refs.grid.refresh();
        }
      },
      load: function () {
        // this.warehouseEditParams.params.dataSource = warehouses;
        this.$refs.grid.ej2Instances.element.addEventListener('mousedown', function (e) {
          var instance = this.ej2_instances[0];
          if (e.target.classList.contains("e-rowcell")) {
            if (instance.isEdit)
              instance.endEdit();
            let index = parseInt(e.target.getAttribute("Index"));
            instance.selectRow(index);
            instance.startEdit();
          }
        });
        this.$refs.grid.ej2Instances.editSettings.allowAdding = this.editing;
        // this.$refs.grid.refresh();
      },
      productFiltering: function (e) {
        var searchData = JSON.parse(JSON.stringify(this.products));
        if (e.text == '') {
          e.updateData(searchData);
        } else {
          var query = new Query().select(['searchName', 'code', 'name', 'id']);
          query = (e.text !== '') ? query.where('searchName', 'contains', e.text, true, true) : query;
          e.updateData(searchData, query);
        }
      },
      warehouseFiltering: function (e) {
        var searchData = JSON.parse(JSON.stringify(this.warehouses));
        if (e.text == '') {
          e.updateData(searchData);
        } else {
          var query = new Query().select(['name', 'id']);
          query = (e.text !== '') ? query.where('name', 'contains', e.text, true, true) : query;
          e.updateData(searchData, query);
        }
      },
      gridActionBegin: function (args) {
        if (args.requestType == 'save') {
          var cancel = false;
          args.data.productName = '';
          args.data.quantity = Math.abs(args.data.quantity);
          if (args.data.productId) {
            var product = this.products.filter(item => item.id == args.data.productId);
            if (product) {
              if (product.length > 0) {
                args.data.productName = product[0].name;
              }
            }
          }
          if (args.data.productName == '') {
            this.$vs.notify({
              title: 'Error al guardar línea',
              text: 'Debe especificar un producto válido',
              color: 'danger'
            });
            cancel = true;
          }
          if (!args.data.quantity || args.data.quantity <= 0) {
            this.$vs.notify({
              title: 'Error al guardar línea',
              text: 'Debe especificar una cantidad mayor a cero',
              color: 'danger'
            });
            cancel = true;
          }
          if (cancel) args.cancel = true;
        }
      },
      gridActionComplete: function (args) {
        if (['add', 'beginEdit'].includes(args.requestType)) {
          this.editingGrid = true;
        } else if (['cancel', 'save'].includes(args.requestType)) {
          this.editingGrid = false
        }
        if (args.action) {
          if (args.action == 'add') {
            this.$refs.grid.ej2Instances.dataSource.shift();
            this.$refs.grid.ej2Instances.dataSource.push(args.data);
            this.$refs.grid.refresh();
            var self = this;
            setTimeout(function () {
              self.$refs.grid.addRecord();
            }, 100);
          }
        }
      },
      reset_data() {
        if (this.$route.params.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.editing = false;
        } else {
          this.$router.push({name: 'stock_transactions'});
        }
      },
      uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
      },
      openUploadFile() {
        this.loadedLines = [];
        this.uploadFileActive = true;
      },
      closeFileUpload(lines) {
        this.uploadFileActive = false;
        for (var i = 0; i < lines.length; i++) {
          this.lines.push({
            productId: lines[i].productId,
            description: lines[i].productName,
            productCode: lines[i].productCode,
            productName: lines[i].productName,
            productSearch: `${lines[i].productCode} | ${lines[i].description}`,
            quantity: lines[i].quantity
          })
        }
        if (this.$refs.grid) {
          this.$refs.grid.refresh();
        }
      },
      getData(id) {
        if (id) {
          if (id == 0) {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
            this.loadLines(this.editing);
            this.data_local.posReference = this.uuidv4();
          } else {
            this.$vs.loading({
              text: 'Cargando datos de transacción de inventario',
              type: 'point'
            });
            var self = this;
            this.$http.post(deltaPOS_config.default.apiURL + '/stock/transactions/data', {id: id, context: this.$store.state.AppActiveUser}).then(response => {
              if (response.data.success) {
                self.data = response.data.data;
                self.data_local = JSON.parse(JSON.stringify(response.data.data));
                self.lines = JSON.parse(JSON.stringify(response.data.data.products));
              } else {
                if (id > 0) {
                  this.id_not_found = true;
                }
              }
              self.$vs.loading.close();
              self.loaded = true;
              self.editing = false;
              self.loadLines(self.editing);
            })
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
          this.loadLines(this.editing);
        }
      },
      validateForm() {
        var message = '';
        if (!this.data_local.documentType || this.data_local.documentType == '') {
          message = 'Debe seleccionar un tipo de documento';
        } else {
          var documentType = this.documentTypes.filter(item => item.code == this.data_local.documentType);
          if (documentType.length > 0) {
            this.data_local.documentTypeFunction = documentType[0].functionId
          } else {
            message = 'Tipo de documento incorrecto';
          }
        }
        if (!this.data_local.date) {
          message = 'Debe seleccionar una fecha de documento';
        }
        if (this.$refs.grid.ej2Instances.dataSource.length == 0) {
          message = 'Debe seleccionar por lo menos un producto en detalle de documento';
        }
        if (message != '') {
          this.$vs.notify({
            title: 'Error al guardar documento',
            text: message,
            color: 'danger'
          });
        }
        return (message == '');
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando información de transacción de inventario',
            type: 'point'
          });
          var self = this;
          this.data_local.id = this.id;
          this.data_local.context = this.$store.state.AppActiveUser;
          this.data_local.products = this.$refs.grid.ej2Instances.dataSource;
          this.data_local.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
          this.$http.post(deltaPOS_config.default.apiURL + '/stock/transactions/save', this.data_local).then(response => {
            if (response.data.success) {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Datos de la transacción de inventario fueron actualizados correctamente',
                color: 'primary'
              });
              if (self.id == 0) {
                self.$router.push({name: 'stock_transaction', params: {id: response.data.data.id}});
              }
              this.editing = false;
            } else {
              self.$vs.notify({
                title: 'Error al actualizar',
                text: response.data.message,
                color: 'danger'
              });
            }
            this.$vs.loading.close();
          });
        }
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a eliminar transacción de inventario "${this.data.document}"`,
          accept: this.deleteRecord,
          acceptText: "Delete"
        })
      },
      deleteRecord() {
        /* Below two lines are just for demo purpose */
        this.$router.push({name: 'stockTransactions'});
        this.showDeleteSuccess()

        /* UnComment below lines for enabling true flow if deleting user */
        // this.$store.dispatch("userManagement/removeRecord", this.user_data.id)
        //   .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
        //   .catch(err => { console.error(err)       })
      },
      showDeleteSuccess() {
        this.$vs.notify({
          color: 'success',
          title: 'Transacción de inventario eliminada',
          text: 'La transacción de inventario seleccionada fue eliminada'
        })
      }
    },

    mounted() {
      this.id = parseInt(this.$route.params.id);
      if (this.id > 0) {
        this.$vs.loading({
          text: 'Cargando documento de inventario',
          type: 'point'
        });
      }
      var self = this;
      this.$http
        .post(deltaPOS_config.default.apiURL + '/stock/document_types/list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token})
        .then(response => {
          if (response.data.success) {
            self.documentTypes = response.data.data;
          }
          self.$http
            .post(deltaPOS_config.default.apiURL + '/stock/warehouses/list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token})
            .then(response => {
              if (response.data.success) {
                self.warehouses = response.data.data;
              }
              self.$http
                .post(deltaPOS_config.default.apiURL + '/lists/get_list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token, list: 'ESTADODOCUMENTO'})
                .then(response => {
                  if (response.data.success) {
                    self.status = response.data.data;
                  }
                  self.$http
                    .post(deltaPOS_config.default.apiURL + '/products/list', this.$store.state.AppActiveUser)
                    .then(response => {
                      if (response.data.success) {
                        self.products = response.data.data;
                      }
                      self.getData(this.id);
                    });
                });
            });
        });
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
  @import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
</style>
